module.exports = __webpack_public_path__ + "static/media/bms4.8f5bb0c2.jpg";